// extracted by mini-css-extract-plugin
export default {"hide-increment-buttons":"NumericInput_hide-increment-buttons__zh06a"};